import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, IconButton, Typography } from '@mui/material';

import { ReactComponent as CloseIcon } from 'assets/icons/CloseIcon.svg';

import { BottomSlider } from 'components/_basic/BottomSlider';
import { Modal } from 'components/_basic/Modal';
import { Responsive } from 'components/_basic/Responsive';

import styles from './index.module.scss';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const DataPrivacyModal: FC<IProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      {open && (
        <Responsive aboveMobile>
          <Modal close={onClose} showCloseButton={false}>
            <Box className={styles.titleContainer}>
              <Typography variant="h3" className={styles.modalTitle}>
                {t('dataPrivacy.title')}
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography variant="body2">{t('dataPrivacy.description')}</Typography>
          </Modal>
        </Responsive>
      )}
      <Responsive mobile>
        <BottomSlider onClose={onClose} isOpened={open}>
          <Box className={styles.titleContainer}>
            <Typography variant="h5" className={styles.modalTitle}>
              {t('dataPrivacy.title')}
            </Typography>
          </Box>
          <Typography variant="body2">{t('dataPrivacy.description')}</Typography>
        </BottomSlider>
      </Responsive>
    </>
  );
};
